import { useQuery } from "@tanstack/react-query"
import { Tables } from "@/integrations/supabase/types"
import { useAuth } from "./useAuth"
import { getLocalProfiles } from "@/lib/db/repos"
import { isTauri } from "@/lib/db/db"
import { supabase } from "@/integrations/supabase/client"
import { ITACONDO_PROFILE_FILTER } from "@/lib/itacondoScope"

type Profile = Tables<"profiles">

export const useProfiles = () => {
  const { profile } = useAuth()
  
  return useQuery({
    queryKey: ["profiles", profile?.id, profile?.condominium_id, profile?.role],
    queryFn: async () => {
      if (!profile) {
        console.log('Usuário não autenticado')
        return []
      }

      if (isTauri()) {
        console.log('Carregando perfis locais (Tauri) para usuário:', profile.id)
        try {
          const data = await getLocalProfiles()
          console.log('Perfis locais carregados:', data.length)
          return data as Profile[]
        } catch (error) {
          console.error('Erro na query de perfis SQLite:', error)
          throw error
        }
      } else {
        console.log('Carregando perfis online (Supabase) para usuário:', profile.id, 'role:', profile.role)
        try {
          let query = supabase.from("profiles").select("*")
          
          if (profile.role === "superadmin") {
            query = query.or(ITACONDO_PROFILE_FILTER)
          } else if (profile.condominium_id) {
            query = query.eq("condominium_id", profile.condominium_id)
          }
          
          const { data, error } = await query.order("full_name")
          
          if (error) {
            console.error('Erro na query de perfis Supabase:', error)
            throw error
          }
          
          console.log('Perfis online carregados:', data?.length)
          return data as Profile[]
        } catch (error) {
          console.error('Erro ao buscar perfis do Supabase:', error)
          throw error
        }
      }
    },
    enabled: !!profile?.id,
    staleTime: 30000,
    refetchOnWindowFocus: true,
    retry: 2
  })
}
